// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"45cead89","158":"db15c2ba","364":"83b5f92a","410":"c1048061","475":"fc523198","947":"d45fc4f2"}[chunkId] + ".chunk.js";
};